<template>
  <div class="input-group input-group-sm widget-carousel-text-input">
    <input
      :id="inputId"
      ref="input"
      type="text"
      class="form-control compact-input"
      :maxlength="maxlength"
      :disabled="disabled"
      :value="value"
      @input="$emit('input', $event.target.value)"
    >
    <div class="input-group-append">
      <button
        type="button"
        class="btn btn-outline-secondary widget-carousel-text-input__bold"
        :title="$t('superUpLang.widget.carousel.textFormat.boldHelp')"
        :aria-label="$t('superUpLang.widget.carousel.textFormat.bold')"
        :disabled="disabled"
        @mousedown.prevent
        @click="applyBold"
      >
        B
      </button>
    </div>
  </div>
</template>

<script>
import { wrapSelectionWithBold } from '../utils/widgetCarouselText';

export default {
  name: 'WidgetCarouselTextInput',

  props: {
    value: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: undefined
    },
    maxlength: {
      type: [Number, String],
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    applyBold() {
      const input = this.$refs.input;

      if (!input) {
        return;
      }

      const result = wrapSelectionWithBold(input.value, input.selectionStart, input.selectionEnd);

      if (this.maxlength && result.value.length > Number(this.maxlength)) {
        return;
      }

      this.$emit('input', result.value);

      this.$nextTick(() => {
        input.focus();
        input.setSelectionRange(result.selectionStart, result.selectionEnd);
      });
    }
  }
};
</script>

<style scoped>
/* Keep the B button on the same row (a global .form-control width overrides Bootstrap's input-group sizing) */
.widget-carousel-text-input {
  flex-wrap: nowrap;
}

.widget-carousel-text-input .compact-input {
  width: 1%;
  min-width: 0;
  height: 34px;
  padding: 6px 10px;
  font-size: 13px;
}

.widget-carousel-text-input__bold {
  min-width: 34px;
  font-weight: 700;
}
</style>
